var _path, _path2, _text, _circle, _text2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v19.429a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V18Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43.429c10-1.4 19-5.4 26-11.4v5.4a6 6 0 0 1-6 6H24Z",
    fill: "#F47216"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 9.6,
    y: 29.9,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 6.6,
    fontWeight: 800,
    letterSpacing: -0.1,
    fill: "#111"
  }, "DISC")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27.6,
    r: 3.3,
    fill: "#F47216"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 31.3,
    y: 29.9,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 6.6,
    fontWeight: 800,
    letterSpacing: -0.1,
    fill: "#111"
  }, "VER")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.f2414581.svg";
export { ForwardRef as ReactComponent };